@if (phase === 'consent') {
<div class="firstTimeLogin_Container" [ngClass]="{'is-mobile-view': isMobileView}">
    <div class="firstTimeLogin_actionSideContainer">
        <div class="firstTimeLogin_actionSide" [ngClass]="{'is-mobile-view': isMobileView}">
            <div class="firstTimeLogin_videoContainer" *ngIf="!presentConsultantVideo">
                <img class="firstTimeLogin_consultantPhoto" src="{{imageRootFolder}}consultant.png">
            </div>
            <div class="firstTimeLogin_videoContainer" *ngIf="presentConsultantVideo">
                <div class="firstTimeLogin_videoSideSubContainer">
                    <button mat-icon-button (click)="muteConsultantVideo()"><mat-icon class="firstTimeLogin_videoMuteIcon" [ngClass]="{'video-is-muted': isVideoMuted}">volume_off</mat-icon></button>
                </div>
                <div class="firstTimeLogin_videoSubContainer">
                    <video #introVideo  class="firstTimeLogin_consultantVideo" [ngClass]="{'is-mobile-view': isMobileView}" autoplay playsinline muted="muted" style="pointer-events: none;" [src]="introVideoAssetName" type="video/mp4">
                    </video>
                </div>
                <div class="firstTimeLogin_videoSideSubContainer">
                    <button mat-icon-button (click)="playVideo()"><mat-icon class="firstTimeLogin_videoMuteIcon" >replay_circle_filled</mat-icon></button>
                </div>
            </div>
            <span class="firstTimeLogin_subHeader" [ngClass]="{'is-mobile-view': isMobileView}">{{'firstTime.header' | translate}} {{user!.firstName!}},</span>
            <div class="moovView_moovReasoningText">
                <span style="display:inline;" class="moovView_moovReasoningText" [innerHtml]="introText" [ngClass]="{'is-mobile-view': isMobileView}"></span>
                <span style="display: inline;" class="moovView_reasoningShowMore" (click)="toggleShowMoreText()"> {{showMoreDetailsButtonHeader}}</span>
            </div>
            <div class="firstTime_importantNotice" [ngClass]="{'is-mobile-view': isMobileView}">
                <span class="firstTime_importantNoticeHeader">{{'firstTime.importantNoticeHeader' | gender | translate}}</span>
                <span class="firstTime_importantNoticeText">{{'firstTime.importantNotice' | translate}}</span>
            </div>
            <span class="firstTime_privacyCheckboxContainer"><mat-checkbox class="firstTime_privacyCheckbox" [(ngModel)]="approvePrivaceyPolicyCheckbox">{{'firstTime.privacyText_1' | gender | translate}} </mat-checkbox><span class="firstTime_privacyLink" (click)="goToPrivacyStatement()">{{'_' + ('firstTime.privacyText_2' | translate)}}</span></span>
            <button mat-raised-button class="firstTimeLogin_button" color="primary" [disabled]="isSubmitDisabled" (click)="onSubmit()">{{'structuredProcessView.introConsent.submitButton' | translate}}</button>
        </div>
    </div>
    <div class="firstTimeLogin_visualSide" *ngIf="!isMobileView">
        <app-carousel class="firstTime_carousel" [commandControlsColor]="'#ffffff'" [showDotsStepper]="true" [showOverControls]="true" [isRTL]="isRTL" [auto]="{ enable: true, timer: 2500 }">
            <ng-container>
                <ng-container *carouselItem>
                    <div class="firstTimeLogin_carouselItemContainer">
                        <span  class="firstTimeLogin_onboardingImageContainer"  [ngClass]="{'is-mobile-view': isMobileView}"><img class="firstTimeLogin_onboardingImage" src="./assets/discovery/on_boarding_1.png"></span>
                        <span class="firstTimeLogin_onboardingTitle"  [ngClass]="{'is-mobile-view': isMobileView}">
                            {{ "firstTime.onboardingTitle_1" | gender | translate }}
                        </span>
                        <span class="firstTimeLogin_onboardingText">
                            {{ "firstTime.onboardingText_1" | gender | translate }}
                        </span>
                    </div>
                </ng-container>
            </ng-container>
            <ng-container>
                <ng-container *carouselItem>
                    <div class="firstTimeLogin_carouselItemContainer">
                        <span  class="firstTimeLogin_onboardingImageContainer"  [ngClass]="{'is-mobile-view': isMobileView}"><img class="firstTimeLogin_onboardingImage" src="./assets/discovery/on_boarding_2.png"></span>
                        <span class="firstTimeLogin_onboardingTitle"  [ngClass]="{'is-mobile-view': isMobileView}">
                            {{ "firstTime.onboardingTitle_2" | gender | translate }}
                        </span>
                        <span class="firstTimeLogin_onboardingText">
                            {{ "firstTime.onboardingText_2" | gender | translate }}
                        </span>
                    </div>
                </ng-container>
            </ng-container>
            <ng-container>
                <ng-container *carouselItem>
                    <div class="firstTimeLogin_carouselItemContainer">
                        <span  class="firstTimeLogin_onboardingImageContainer"  [ngClass]="{'is-mobile-view': isMobileView}"><img class="firstTimeLogin_onboardingImage" src="./assets/discovery/on_boarding_3.png"></span>
                        <span class="firstTimeLogin_onboardingTitle"  [ngClass]="{'is-mobile-view': isMobileView}">
                            {{ "firstTime.onboardingTitle_3" | gender | translate }}
                        </span>
                        <span class="firstTimeLogin_onboardingText">
                            {{ "firstTime.onboardingText_3" | gender | translate }}
                        </span>
                    </div>
                </ng-container>
            </ng-container>
        </app-carousel>
    </div>
</div>
} @else if (phase === 'discovery') {
    @if (user?.discoveryType === eDiscoveryTypeEnum.Wizard) {
        <app-embedded-discovery-wizard
            (discoveryCompleted)="onDiscoveryCompleted()">
        </app-embedded-discovery-wizard>
    } @else {
        <app-embedded-discovery-chat
            (discoveryCompleted)="onDiscoveryCompleted()">
        </app-embedded-discovery-chat>
    }
}
